import styled from 'styled-components';
import { Input } from 'antd';

export const StyledInput = styled(Input)`
  height: 40px;
  font-size: 16px;
  font-weight: 400;
  border-radius: 8px;
  color: rgba(22, 23, 26, 1);
  border: 1px solid ${({ theme }) => theme.palette.neutral[300]};

  &:hover,
  &:focus {
    box-shadow: none !important;
    border-color: ${({ theme }) => theme.palette.secondary.main} !important;
  }

  &.ant-input-disabled,
  &.ant-input-affix-wrapper-disabled,
  &.ant-input-affix-wrapper-readonly {
    color: ${({ theme }) => theme.palette.text.primary};
    -webkit-text-fill-color: ${({ theme }) => theme.palette.text.primary};
    background-color: ${({ theme }) => theme.palette.background.default};
    border-color: ${({ theme }) => theme.palette.neutral[300]} !important;
    cursor: not-allowed;

    .ant-input {
      color: ${({ theme }) => theme.palette.text.primary};
      -webkit-text-fill-color: ${({ theme }) => theme.palette.text.primary};
      cursor: not-allowed;
    }

    &:hover,
    &:focus {
      border-color: ${({ theme }) => theme.palette.neutral[300]} !important;
      box-shadow: none !important;
    }
  }

  .ant-input-prefix {
    margin-inline-end: 8px;
    .anticon {
      font-size: 16px;
    }
  }
`;
